import { Match, Show, Switch, onMount, useContext } from 'solid-js';
import { AppContext } from '../../app-context-provider/app-context-provider';
import theme from '../../style/theme';
import { LoginMenuDesktop } from './login-menu-desktop/login-menu-desktop';
import { LoginMenuMobile } from './login-menu-mobile/login-menu-mobile';
import { logOut } from '../../tools/log-out';

export const LoginMenu = () => {

    const { viewport, siteInfo, appStore } = useContext(AppContext);

    const { loginMenuOpen, closeLoginMenu } = appStore;

    // if user hits esc key, close the login menu
    onMount(() => {
        if (window) {
            window.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') {
                    closeLoginMenu();
                }
            });
        }
    });

    return (
        <Show when={loginMenuOpen()}>
            <div class="[container-type:inline-size] fixed inset-0 z-10 bg-white overflow-y-auto overflow-x-hidden">
                <Switch>
                    <Match when={viewport.width > theme.breakpoints.TABLET}>
                        <LoginMenuDesktop
                            handleCloseMenuClick={() => closeLoginMenu()}
                            handleSignOutClick={() => logOut(siteInfo.siteType)}
                        />
                    </Match>
                    <Match when={viewport.width <= theme.breakpoints.TABLET}>
                        <LoginMenuMobile
                            handleCloseMenuClick={() => closeLoginMenu()}
                            handleSignOutClick={() => logOut(siteInfo.siteType)}
                        />
                    </Match>
                </Switch>
            </div>
        </Show>
    );
};
export type LoginMenuProps = {
};
